export default class CheckboxGroupService {
  static getSelectedUpdated = (currentSelected, option, idProperty) => {
    const i = currentSelected.findIndex((a) => a == option[idProperty]);
    if (i >= 0) {
      currentSelected.splice(i, 1);
    } else {
      currentSelected.push(option[idProperty]);
    }

    return currentSelected;
  };

  static getSelectedUpdated = (currentSelected, option) => {
    const i = currentSelected.findIndex((a) => a == option);
    if (i >= 0) {
      currentSelected.splice(i, 1);
    } else {
      currentSelected.push(option);
    }

    return currentSelected;
  };
}
